<template>
	<b-card :header="$t('sidebar.pos.discountForCard')">
		<div class="row">
			<div class="col-8">
				<div class="row" v-for="(item, index) in clientDiscountArray" :key="index">
					<div class="col-sm-5">
						<b-form-group
							label-size="sm"
							class="required"
							label-for="lastName">
							<label class="lebeltop">{{$t('pos.sum')}}</label>

							<b-form-input size="sm" :placeholder="$t('pos.sum')"
										  type="text"
										  id="amount"
										  ref="amountRef"
										  v-on:keyup.enter="enterAmount(index)"
										  v-model="item.amount"/>
						</b-form-group>
					</div>
					<div class="col-sm-5">
						<b-form-group
							label-size="sm"
							class="required"
							label-for="lastName">
							<label class="lebeltop">{{$t('promo-to-product.percentage')}}</label>

							<b-form-input size="sm" :placeholder="$t('promo-to-product.percentage')"
										  type="text"
										  id="percentage"
										  :required="true"
										  ref="percentageRef"
										  v-on:keyup.enter="enterPercentage(index)"
										  v-model="item.percentage"/>
						</b-form-group>
					</div>
					<div class="col-2" v-if="item.id || index>0">
						<i class="fa fa-remove" style="color:red;padding-top: 34px;cursor: pointer"
						   @click="deleteEvent(item,index)"></i>
					</div>
				</div>
			</div>
			<div class="col-4">
				<div class="row">
					<div class="col-5">
						<label style="font-size: 12px">{{$t('client.newClient')}}</label>
						<b-button variant="btn btn-info" size="sm" block @click="addClck">
							{{$t('client.newClient')}}
						</b-button>
					</div>
					<div class="col-5">
						<label style="padding-right: 45px;font-size: 12px">{{$t('actions.save')}}</label>
						<b-button variant="btn btn-success" block size="sm" @click="saveClick">{{$t('actions.save')}}
						</b-button>
					</div>
				</div>
			</div>
		</div>
	</b-card>
</template>

<script>
	import {mapGetters, mapActions, mapState} from 'vuex'

	export default {
		name: "DiscountForCard",
		data() {
			return {
				clientDiscountArray: [{
					amount: '',
					percentage: ''
				}],
				arrayFinish: [],
			}

		},
		computed: {
			...mapState('clients', [
				'discountForCardResSucces', 'listDiscountForCardArray'
			]),

		},
		methods: {
			addClck() {
				this.clientDiscountArray.push({
					amount: '',
					percentage: ''
				});
			},

			enterAmount(index) {

				this.$refs.percentageRef[index].focus();


			},
			async enterPercentage() {

			},
			async saveClick() {

				for (let i = 0; i < this.clientDiscountArray.length; i++) {
					if (this.clientDiscountArray[i].amount != "" && this.clientDiscountArray[i].percentage != ""
						&& this.clientDiscountArray[i].amount > 0 && this.clientDiscountArray[i].percentage > 0) {
						this.arrayFinish.push(this.clientDiscountArray[i]);

					}

				}
				await this.createDiscountForClient(this.arrayFinish);
				this.arrayFinish = [];
				await this.getAllDiscountForClient();
				if (this.listDiscountForCardArray.length > 0) {
					this.clientDiscountArray = this.listDiscountForCardArray;
				}
				if (this.discountForCardResSucces == "success") {
					this.$vs.notify({
						title: 'Скидки успешно сохранены',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}

			},
			async deleteEvent(item, index) {
				if (item.id) {
					await this.deleteDiscountForClient(item);
					await this.getAllDiscountForClient();
					if (this.listDiscountForCardArray.length >= 0) {
						this.clientDiscountArray = this.listDiscountForCardArray;

					}
					if (index == 0 && this.listDiscountForCardArray.length == 0) {
						this.clientDiscountArray.push({
							amount: '',
							percentage: ''
						})
					}


				}

				else {
					this.clientDiscountArray.splice(index, 1);
				}

			},
			...mapActions('clients', [
				'createDiscountForClient', 'getAllDiscountForClient', 'deleteDiscountForClient'
			]),
		},
		async mounted() {
			await this.$refs.amountRef[0].focus();
			await this.getAllDiscountForClient();
			if (this.listDiscountForCardArray.length > 0) {
				this.clientDiscountArray = this.listDiscountForCardArray;
			}

		}
	}
</script>

<style scoped>
	.isErrorDepartment {
		color: red;
		font-size: 12px;
		margin-left: 20px;
	}

</style>
